export const STATUS_CHOICES = [
  { id: 'refund', name: 'Рефанд' },
  { id: 'chargeback', name: 'Чарджбек' },
];
